import { Typography } from '@mui/material'
import PlatformBrandedShell from './PlatformBrandedShell'

// Shown when GET /identity-config returns 404 — the host's subdomain isn't a recognised workspace
// (D23). Rendered OUTSIDE MsalProvider AND the Intl/Theme providers (index.tsx boots IdentityConfigLoader
// above them), so it uses no MSAL/intl hooks and plain strings; MUI falls back to its default theme.
// Platform-branded (PlatformBrandedShell) so it matches /login and /signup.
const InvalidWorkspacePage = () => (
  <PlatformBrandedShell>
    <Typography variant='h5' component='h1' textAlign='center'>
      Workspace not found
    </Typography>
    <Typography variant='body2' color='text.secondary' textAlign='center'>
      This address isn&apos;t a recognised LogikSpark workspace. Check the URL for typos, or contact your
      administrator for the correct sign-in link.
    </Typography>
  </PlatformBrandedShell>
)

export default InvalidWorkspacePage
